<template>
  <v-dialog
    :value="isAddNewFormularioSidebarActive"
    max-width="800px"
    persistent
  >
    <v-card class="pa-sm-8 pa-2">
      <btn-close-dialog :handle-click="resetFormularioData" />

      <v-card-title class="justify-center text-h5 pt-0">
        Associar Formulário
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model.trim="tipoSolicitacaoFormularioData.formularioId"
                dense
                outlined
                label="Formulários"
                item-text="formularioNome"
                item-value="formularioId"
                placeholder="Formulários"
                :rules="[validators.select]"
                :items="formulariosNaoAssociados"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              md="12"
              sm="12"
            >
              <h3 class="font-weight-medium">
                Visibilidade:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              z-index="10"
              @click="toggleCheckbox(['visivelSolicitante', 'editavelSolicitante', 'visivelSolicitanteImpressao' ])"
            >
              <v-card
                height="100"
                :color="tipoSolicitacaoFormularioData.visivelSolicitante ? '#9055fd1e' : undefined"
                elevation="1"
                class="p-0"
                outlined
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelSolicitante"
                    label="Visivel para Solicitante no autoatendimento"
                    :rules="[visivelRequired]"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox(['visivelAgente', 'editavelAgente', 'visivelAgenteImpressao'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelAgente ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelAgente"
                    label="Visivel para Agente no Atendimento"
                    :rules="[visivelRequired]"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              md="12"
              sm="12"
            >
              <h3 class="font-weight-medium">
                Edição:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelSolicitante', 'visivelSolicitante'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.editavelSolicitante ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.editavelSolicitante"
                    label="Editável para Solicitante no autoatendimento"
                    :disabled="tipoSolicitacaoFormularioData.visivelSolicitante ? false : true"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelAgente', 'visivelAgente'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.editavelAgente ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.editavelAgente"
                    :disabled="tipoSolicitacaoFormularioData.visivelAgente ? false : true"
                    label="Editável para Agente no Atendimento"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              md="12"
              sm="12"
            >
              <h3 class="font-weight-medium">
                Impressão:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['visivelSolicitanteImpressao', 'visivelAgenteImpressao'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelSolicitanteImpressao ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelSolicitanteImpressao"
                    label="Impressão para Solicitante no autoatendimento"
                    :disabled="tipoSolicitacaoFormularioData.visivelSolicitante ? false : true"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['visivelAgenteImpressao', 'visivelAgenteImpressao'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelAgenteImpressao ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelAgenteImpressao"
                    :disabled="tipoSolicitacaoFormularioData.visivelAgente ? false : true"
                    label="Impressão para Agente no Atendimento"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="tipoSolicitacaoFormularioData.ordem"
                label="Ordem"
                dense
                outlined
                validate-on-blur
                hide-details
                :items="ordensPermitidas"
                :rules="[validators.select]"
              />
            </v-col>
          </v-row>

          <v-row class="mt-6 mb-4">
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                color="secondary"
                class="mr-4"
                outlined
                type="reset"
                @click="resetFormularioData"
              >
                Cancelar
              </v-btn>

              <v-btn
                color="primary"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-6"
                  indeterminate
                  color="secundary"
                />
                <span v-else>Associar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import { mdiClose } from '@mdi/js'
import router from '@/router'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import TipoSolicitacaoFormularioModel from '@/models/entities/tipo-solicitacao/TipoSolicitacaoFormularioModel'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  components: {
    BtnCloseDialog,
  },

  props: {
    isAddNewFormularioSidebarActive: {
      type: Boolean,
      required: true,
    },
    ordensPermitidas: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    formulariosNaoAssociados: [],
  }),

  watch: {
    isAddNewFormularioSidebarActive() {
      this.getFormulariosNaoAssociados()
    },
  },

  mounted() {
    this.getFormulariosNaoAssociados()
  },

  methods: {
    async getFormulariosNaoAssociados() {
      this.formulariosNaoAssociados = await TipoSolicitacaoService.getFormulariosNaoAssociados(router.currentRoute.params.id)
    },
  },

  setup(_, { emit }) {
    const formRef = ref(null)
    const loading = ref(false)

    const tipoSolicitacaoFormularioData = ref(new TipoSolicitacaoFormularioModel())

    function visivelRequired() {
      if (tipoSolicitacaoFormularioData.value.visivelSolicitante || tipoSolicitacaoFormularioData.value.visivelAgente) {
        return true
      }
      return ''
    }

    function toggleCheckbox(checkbox) {
      tipoSolicitacaoFormularioData.value[checkbox[0]] = !tipoSolicitacaoFormularioData.value[checkbox[0]]
      tipoSolicitacaoFormularioData.value[checkbox[1]] = !tipoSolicitacaoFormularioData.value[checkbox[1]]
      tipoSolicitacaoFormularioData.value[checkbox[2]] = !tipoSolicitacaoFormularioData.value[checkbox[2]]
    }

    function toggleCheckbox1(checkbox) {
      if (tipoSolicitacaoFormularioData.value[checkbox[1]]) {
        tipoSolicitacaoFormularioData.value[checkbox[0]] = !tipoSolicitacaoFormularioData.value[checkbox[0]]
      }
    }

    const errorMsg = ref('Entre em contato com o servidor.')
    function resetFormularioData() {
      tipoSolicitacaoFormularioData.value = new TipoSolicitacaoFormularioModel()
      emit('update:is-add-new-formulario-sidebar-active', false)
    }

    async function handleSubmit() {
      if (tipoSolicitacaoFormularioData.value.visivelSolicitante || tipoSolicitacaoFormularioData.value.visivelAgente) {
        try {
          loading.value = true
          await TipoSolicitacaoService.associarFormulario(router.currentRoute.params.id, tipoSolicitacaoFormularioData.value)
          emit('refetch-data')
          resetFormularioData()
        } finally {
          loading.value = false
        }
      }
    }

    watch(
      () => tipoSolicitacaoFormularioData.value.visivelSolicitante,
      () => { tipoSolicitacaoFormularioData.value.editavelSolicitante = tipoSolicitacaoFormularioData.value.visivelSolicitante },
      { immediate: true },
    )

    watch(
      () => tipoSolicitacaoFormularioData.value.visivelAgente,
      () => { tipoSolicitacaoFormularioData.value.editavelAgente = tipoSolicitacaoFormularioData.value.visivelAgente },
      { immediate: true },
    )

    return {
      resetFormularioData,
      handleSubmit,
      toggleCheckbox,
      toggleCheckbox1,
      visivelRequired,
      formRef,
      tipoSolicitacaoFormularioData,
      loading,
      errorMsg,
      validators: {
        required,
        select,
      },
      icons: { mdiClose },
    }
  },
}
</script>
